import { NgModule } from '@angular/core';
import { InfoblockStoreModule } from './store/infoblock-store.module';

@NgModule({
  imports: [InfoblockStoreModule],
})
export class MainInfoblockDataAccessModule {}
